/**
 * Vue
 * @type {Vue | VueConstructor}
 */
import Vue from 'vue';
import { notifyMixin } from './mixins/notify';
import { formMixin } from './mixins/form';

import Dropzone from './components/Dropzone.vue';
import SupportRequestDetailTable from './components/SupportRequestDetailTable.vue';

/**
 * App
 * @constructor
 */
window.Lagina = new Vue({
  el: '#app',
  mixins: [notifyMixin, formMixin],
  components: {
    Dropzone,
    SupportRequestDetailTable,
  },
  computed: {
    locale: function () {
      return window.locale;
    },
  },
});
